<template>
    <div class="flex justify-content-center">
        <div class="change-password-panel-content flex justify-content-center p-6">
            <Form @submit="change" v-slot="{isSubmitting}">
                <div class="flex flex-column align-items-center gap-3">
                    <div class="text-center">
                        <h2>Change password</h2>
                        <div v-show="!afterChange">
                            Enter a new password. The password must contain at least 8 characters.
                        </div>
                    </div>
                    <div v-show="!afterChange" class="w-full inputs-box" @keyup.enter="change">
                        <CustomPassword v-model="changePasswordForm.newPassword"
                                        class="input-password w-10" label="New password" name="newPassword"
                                        rules="required|validPassword" :feedback="true"/>
                        <CustomPassword v-model="changePasswordForm.repeatPassword" label="Repeat password"
                                        name="repeatPassword"
                                        rules="required|confirmed:@newPassword,Passwords"
                                        class="w-10"/>
                    </div>
                    <div v-show="!afterChange" class="">
                        <CustomButton label="Change password" @click="change" :disabled="isSubmitting"/>
                    </div>
                </div>
                <div class="">
                    <div v-show="afterChange" class="">
                        <div v-if="success">
                            The password has been changed.
                            <router-link :to="{name: 'login'}">Sign in</router-link>
                        </div>
                        <div v-else>
                            The password change was unsuccessful.
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
    import {Form} from "vee-validate";
    import CustomButton from "@/components/form/CustomButton.vue";
    import {changePassword} from "@/swagger/vue-api-client";
    import CustomPassword from "../components/form/CustomPassword";

    export default {
        name: "ChangePasswordView",
        // eslint-disable-next-line vue/no-reserved-component-names
        components: {
            Form,
            CustomPassword,
            CustomButton,
        },

        computed: {},

        data() {
            return {
                changePasswordForm: {
                    resetPasswordToken: "",
                    newPassword: "",
                },
                repeatPassword: "",
                afterChange: false,
                success: false,
            };
        },

        mounted() {
            this.changePasswordForm.resetPasswordToken = this.$route.query.resetPasswordToken;
        },

        methods: {
            change() {
                changePassword({
                    body: this.changePasswordForm,
$config: {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    },
                }).then((response) => {
                    this.success = response.data;
                    this.afterChange = true;
                });
            },
        },
    };
</script>

<style lang="scss">
    @import "../assets/theme/mytheme/variables";
    // @import "assets/scss/change-password";
    .change-password-panel-content {
        max-width: 1050px;
        width: 90%;
        background-color: var(--primary-color-light);
        height: 400px;
        input, input:hover {
            border-color: var(--text-color) !important;
        }
        .custom-input-text, .custom-password {
            padding-left: 50px;
            input {
                background-color: var(--text-light-color);
            }
            .custom-label {
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 40px;
                text-align: right;
            }
        }
        .inputs-box {
            position: relative;
            left: 94px;
        }
        @media screen and (max-width: 800px) {
            .custom-input-text, .custom-password {
                padding-left: 130px;
                .custom-label {
                    left: 120px;
                }
            }
            .inputs-box {
                left: 54px;
            }
        }
        @media screen and (max-width: 550px) {
            .custom-input-text, .custom-password {
                padding-left: 90px;
                .custom-label {
                    left: 80px;
                }
            }
            .inputs-box {
                left: 54px;
            }
        }
        @media screen and (max-width: 400px) {
            height: auto;
            width: 100%;
            .custom-input-text, .custom-password {
                padding-left: 65px;
                .custom-label {
                    left: 60px;
                }
            }
            .inputs-box {
                left: 47px;
            }
        }
    }
</style>
